<nav #navbarCommon class="navbar navbar-expand-lg navbar-light fixed-top bg-white">
  <div class="container">
    <img [src]="'assets/logos/logo.png'" width="120px" height="100%" class="d-inline-block align-top" alt="">
    <div class="text-center justify-content-center">
      <a class="d-inline-block nav-item nav-link">
        <img src="assets/flags/es.png" height="20" class="d-inline-block align-top" (click)="changeLanguage('es')" alt="">
      </a>
      <a class="d-inline-block nav-item nav-link">
        <img src="assets/flags/en.png" height="20" class="d-inline-block align-top" (click)="changeLanguage('en')" alt="">
      </a>
    </div>
  </div>
</nav>

<div class="container mt-5 pt-5">
  <blockquote class="blockquote text-center footerSpace">
    <p-card>
      <div class="col-12 text-center" >
        <h2 >{{"shared.contact_us.title" | translate}}</h2>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <app-contact-us textColor="#000000"></app-contact-us>
          </div>
        </div>
      </div>
    </p-card>
  </blockquote>
</div>
